import React, { useState } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import { toast } from "react-hot-toast";

const WalletToTransferService = () => {
  const [userAuthData, setUserAuthData] = useState();
  const [authError, setAuthError] = useState("");
  const [isValidUser, setIsValidUser] = useState(false);
  const [formData, setFormData] = useState({
    mobile: "",
    amount: "",
    remark: "",
  });
  const [formErrors, setFormErrors] = useState({
    amount: "",
    remark: "",
  });

  const getUserAuthentication = async (mobile) => {
    try {
      const bodyObject = { MobileNo: mobile };

      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetUserInfo",
        data: bodyObject,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.statuscode === 1 && res?.wtwuserinfo) {
        setUserAuthData({
          outletName: res.wtwuserinfo.outletName,
          userID: res.wtwuserinfo.userID,
        });
        setAuthError("");
        return true;
      } else {
        setUserAuthData(null);
        setAuthError(res?.msg || "Invalid user");
        return false;
      }
    } catch (error) {
      console.error("Error getProfileReport:", error);
      setUserAuthData(null);
      setAuthError("Something went wrong");
      return false;
    }
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "mobile" && value.length === 10) {
      const isValid = await getUserAuthentication(value);
      setIsValidUser(isValid);
    } else if (name === "mobile") {
      setIsValidUser(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    const amountNum = parseFloat(formData.amount);

    if (!formData.amount || isNaN(amountNum) || amountNum <= 0) {
      errors.amount = "Please enter a valid amount";
    }

    if (!formData.remark.trim()) {
      errors.remark = "Remark is required";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0 && isValidUser) {
      try {
        const bodyObject = {
          a: amountNum,
          w: 1,
          id: userAuthData?.userID || "",
          vpa: formData.remark,
        };

        const res = await ApiCalling.apiClient.request({
          method: "POST",
          url: "/WalletToWalletTransfer",
          data: bodyObject,
          headers: {
            session: sessionStorage.getItem("session"),
            sessionID: sessionStorage.getItem("sessionID"),
            userID: sessionStorage.getItem("userID"),
          },
        });

        if (res?.statuscode === 1) {
          setFormData({ mobile: "", amount: "", remark: "" });
          setUserAuthData(null);
          setIsValidUser(false);
          toast.success(res?.msg);
        } else {
          toast.error(res?.msg || "Transfer failed.");
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    }
  };

  return {
    handleInputChange,
    handleSubmit,
    formData,
    userAuthData,
    authError,
    isValidUser,
    formErrors,
  };
};

export default WalletToTransferService;
